import clientService from "@/services/client";

export default {
  methods: {
    async getClientName(id) {
      const vue = this;
      return await clientService
        .getContact(id)
        .then((res) => {
          if (!res.success) {
            return;
          }
          return res.data.name;
        })
        .catch((err) => {
          // vue.callToaster(vue.$t("problem-arise"));
          return;
        });
		},
		async getClient(id) {
      const vue = this;
      return await clientService
        .getContact(id)
        .then((res) => {
          if (!res.success) {
            return;
          }
          return res.data;
        })
        .catch((err) => {
          // vue.callToaster(vue.$t("problem-arise"));
          return;
        });
    },
  },
};
